import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InvitationDrawerService } from '../services/invitation-drawer.service';
import { InvitationFormComponent } from '../invitation-form/invitation-form.component';
import { InvitationResponse } from '../models/invitation.model';
import { ModalComponent } from '../../../shared/components/ui/modal/modal.component';

@Component({
  selector: 'app-invitation-form-drawer',
  standalone: true,
  imports: [CommonModule, InvitationFormComponent, ModalComponent],
  template: `
    <app-modal [isOpen]="isOpen" (close)="close()" className="max-w-5xl mx-4 sm:mx-6">
      @if (isOpen) {
      <div class="p-6 sm:p-8">
        <!-- Header -->
        <div class="mb-6">
          <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Nueva invitación</h2>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Envía una invitación para que un nuevo usuario se una a tu organización.
          </p>
        </div>

        <!-- Content -->
        <app-invitation-form
          (saved)="onSaved($event)"
          (cancelled)="close()"
        />
      </div>
      }
    </app-modal>
  `
})
export class InvitationFormDrawerComponent implements OnInit, OnDestroy {
  @ViewChild(InvitationFormComponent) formComponent?: InvitationFormComponent;

  isOpen = false;
  private readonly destroy$ = new Subject<void>();

  constructor(private drawerService: InvitationDrawerService) {}

  ngOnInit(): void {
    this.drawerService.state.pipe(takeUntil(this.destroy$)).subscribe(state => {
      const wasOpen = this.isOpen;
      this.isOpen = state.isOpen;

      if (state.isOpen && !wasOpen) {
        setTimeout(() => { this.formComponent?.reset(); }, 0);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSaved(invitation: InvitationResponse): void {
    this.drawerService.notifySaved(invitation);
    this.drawerService.close();
  }

  close(): void {
    this.drawerService.close();
  }
}
